import classNames from "classnames";
import moment from "moment";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";

import * as ArticleController from "../../controllers/article-controller";
import { getRandomInt } from "../../utils";
import { DATE_FORMAT_UTC } from "../../utils/consts";
import { filterDraftArticles } from "../../utils/filterDraft";
import { RecommendedRandomCard } from "./RecommendedRandomCard";

interface IProps {
  tagslug?: string;
  excludeId?: number;
}
const LIST_SIZE = 3;

export const RecommendedRandom = ({ tagslug, excludeId }: IProps) => {
  const [showAnotherNews] = useState(true);
  const { t } = useTranslation();

  const [recommendedArticles, setRecommendedArticles] =
    useState<Nullable<ArticleResponse[]>>();

  useEffect(() => {
    const fetchRecommendedArticles = async () => {
      // 1st response to get total and after random
      const totalResponse = await ArticleController.getArticlesByFilter({
        filter: {
          tagslug: tagslug,
          is_draft: false,
          end_date: moment(new Date()).format(DATE_FORMAT_UTC),
        },
        start: 0,
        total: 0,
      });

      if (!totalResponse?.total) return;

      const response = await ArticleController.getArticlesByFilter({
        filter: {
          tagslug: tagslug,
          is_draft: false,
          end_date: moment(new Date()).format(DATE_FORMAT_UTC),
        },
        start: getRandomInt(totalResponse?.total - (LIST_SIZE + 1), true),
        total: LIST_SIZE + 2,
      });

      const items =
        response?.list
          .filter((item) => item.article_id !== excludeId)
          .slice(0, LIST_SIZE) || null;
      setRecommendedArticles(filterDraftArticles(items));
    };

    tagslug && fetchRecommendedArticles();
  }, [excludeId, tagslug]);

  if (!recommendedArticles) return null;

  return (
    <aside
      className={classNames(
        "aside__block another-articles",
        showAnotherNews && "is-on"
      )}
    >
      <h3 className="block-title aside__title">{t("OtherArticles")}</h3>
      {recommendedArticles?.map((article) => (
        <RecommendedRandomCard key={article.article_index} card={article} />
      ))}
    </aside>
  );
};
